import { useState } from 'react'
import { Modal, Upload } from 'antd'

const emptyData = []

const DamagedPicture = ({ data = emptyData }) => {
  const [isPreview, setIsPreview] = useState(false)
  const [picturePreviewInfo, setPicturePreviewInfo] = useState({
    previewImage: '',
    previewTitle: '',
  })

  const onPicturePreviewHandler = async (file) => {
    setPicturePreviewInfo({
      previewImage: file?.url ?? file?.imageBase64,
      previewTitle: file?.name ?? file?.url.slice(Math.max(0, file?.url.lastIndexOf('/') + 1)),
    })
    setIsPreview(true)
  }

  const onClosePreviewHandler = () => {
    setIsPreview(false)
  }

  return (
    <>
      <Upload
        className="upload-block__content"
        fileList={data}
        listType="picture-card"
        showUploadList={{
          showRemoveIcon: false,
        }}
        onPreview={onPicturePreviewHandler}
      />
      <Modal
        footer={null}
        open={isPreview}
        title={picturePreviewInfo?.previewTitle}
        onCancel={onClosePreviewHandler}
      >
        <img
          alt="example"
          src={picturePreviewInfo?.previewImage}
          style={{ width: '100%' }}
        />
      </Modal>
    </>
  )
}

export default DamagedPicture
